// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M7.00774 21.0014H2V14.9956L7.00774 9.979V21.0014Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M22 21.0065H16.9923V9.91893L22 4.00193V21.0065Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M9.51717 3.99316L2.99447 3.99318L12.8191 13.2574L16.1576 9.91893L9.51717 3.99316Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-logo-xiaomareport-filled')
export default class LogoXiaomareportFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'logo-xiaomareport-filled',
    }
  }
}
